var Header;
(function (Header) {
    __once('header', () => {
        const headerNode = document.querySelector('header#header');
        const burgerIconNode = headerNode === null || headerNode === void 0 ? void 0 : headerNode.querySelector('.mefi-burger');
        const burgerCloseIconNode = headerNode === null || headerNode === void 0 ? void 0 : headerNode.querySelector('.header-mobile-menu .mefi-close');
        const mainMenuSectionNode = headerNode === null || headerNode === void 0 ? void 0 : headerNode.querySelector('.header-menu');
        const mainMenuNodelist = headerNode === null || headerNode === void 0 ? void 0 : headerNode.querySelectorAll('.header-menu .nav-main-item');
        const mainMenuParentNodelist = headerNode === null || headerNode === void 0 ? void 0 : headerNode.querySelectorAll('.header-menu .nav-main-item.has-submenu');
        const HIDE_CLASS = 'hidden';
        const SUBMENU_OPEN_CLASS = 'open';
        const STICKY_CLASS = 'sticky';
        const TOGGLE_MENU_MOBILE_CLASS = 'show';
        const OPEN_MENU_CLASS = 'submenu-open';
        const SUBMENU_WRAPPER_CLASS = 'nav-sub';
        const MEDIA_BREAKPOINT_SM = 576;
        const MEDIA_BREAKPOINT_MD = 768;
        const MEDIA_BREAKPOINT_LG = 992;
        const MEDIA_BREAKPOINT_XL = 1200;
        const MEDIA_BREAKPOINT_XXL = 1400;
        const KEY_ENTER = 'Enter';
        function burgerIconEvent() {
            burgerIconNode.addEventListener('click', (event) => {
                burgerIconNode.classList.add(HIDE_CLASS);
                burgerCloseIconNode.classList.remove(HIDE_CLASS);
                mainMenuSectionNode.classList.add(TOGGLE_MENU_MOBILE_CLASS);
            });
            burgerCloseIconNode.addEventListener('click', (event) => {
                burgerCloseIconNode.classList.add(HIDE_CLASS);
                burgerIconNode.classList.remove(HIDE_CLASS);
                mainMenuSectionNode.classList.remove(TOGGLE_MENU_MOBILE_CLASS);
            });
        }
        function openSubmenuDSK(menu) {
            menu.classList.add(OPEN_MENU_CLASS);
            const menuLink = menu.querySelector('.nav-main-link');
            menuLink.setAttribute('aria-expanded', 'true');
            const submenu = menu.querySelector(`.${SUBMENU_WRAPPER_CLASS}`);
            submenu === null || submenu === void 0 ? void 0 : submenu.classList.add(SUBMENU_OPEN_CLASS);
        }
        function closeSubmenuDSK(menu) {
            menu === null || menu === void 0 ? void 0 : menu.classList.remove(OPEN_MENU_CLASS);
            const menuLink = menu === null || menu === void 0 ? void 0 : menu.querySelector('.nav-main-link');
            menuLink === null || menuLink === void 0 ? void 0 : menuLink.setAttribute('aria-expanded', 'false');
            const submenu = menu === null || menu === void 0 ? void 0 : menu.querySelector(`.${SUBMENU_WRAPPER_CLASS}`);
            submenu === null || submenu === void 0 ? void 0 : submenu.classList.remove(SUBMENU_OPEN_CLASS);
        }
        function submenuEventDSK() {
            mainMenuNodelist.forEach(menuItem => {
                menuItem.addEventListener('mouseover', (event) => {
                    openSubmenuDSK(menuItem);
                });
                menuItem.querySelector('a').addEventListener('focus', (event) => {
                    mainMenuNodelist.forEach(menu => {
                        closeSubmenuDSK(menu);
                    });
                    menuItem.classList.add(OPEN_MENU_CLASS);
                });
                menuItem.querySelector('a').addEventListener('keyup', function (event) {
                    if (event.key === KEY_ENTER) {
                        const submenu = event.target.parentNode.querySelector(`.${SUBMENU_WRAPPER_CLASS}`);
                        if (submenu.classList.contains(SUBMENU_OPEN_CLASS)) {
                            closeSubmenuDSK(menuItem);
                        }
                        else {
                            openSubmenuDSK(menuItem);
                        }
                    }
                });
                menuItem.querySelector('a').addEventListener('blur', (event) => {
                    menuItem.classList.remove(OPEN_MENU_CLASS);
                });
            });
            mainMenuSectionNode.addEventListener('mouseout', (event) => {
                const currentMenu = mainMenuSectionNode.querySelector(`.${OPEN_MENU_CLASS}`);
                const submenu = currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.querySelector('.nav-sub');
                if (event.target != currentMenu || event.target != submenu) {
                    closeSubmenuDSK(currentMenu);
                }
            });
        }
        function submenuEventTAB() {
            mainMenuParentNodelist.forEach(currentItem => {
                currentItem.addEventListener('click', (event) => {
                    const previousItem = mainMenuSectionNode.querySelector(`.has-submenu.${SUBMENU_OPEN_CLASS}`);
                    if (previousItem != currentItem) {
                        previousItem === null || previousItem === void 0 ? void 0 : previousItem.classList.toggle(SUBMENU_OPEN_CLASS);
                        previousItem === null || previousItem === void 0 ? void 0 : previousItem.setAttribute('aria-expanded', String(previousItem.classList.contains(SUBMENU_OPEN_CLASS)));
                    }
                    currentItem.classList.toggle(SUBMENU_OPEN_CLASS);
                    currentItem.setAttribute('aria-expanded', String(currentItem.classList.contains(SUBMENU_OPEN_CLASS)));
                });
            });
        }
        function submenuEventMOB() {
            mainMenuParentNodelist.forEach(menuItem => {
                const anchorNode = menuItem.querySelector('.nav-main-link');
                anchorNode.addEventListener('click', (event) => {
                    menuItem.classList.add(SUBMENU_OPEN_CLASS);
                    const menuLink = menuItem.querySelector('.nav-main-link');
                    menuLink.setAttribute('aria-expanded', 'true');
                });
                const backButton = menuItem.querySelector('.nav-sub-mobile-back');
                backButton === null || backButton === void 0 ? void 0 : backButton.addEventListener('click', (event) => {
                    menuItem.classList.remove(SUBMENU_OPEN_CLASS);
                    const menuLink = menuItem.querySelector('.nav-main-link');
                    menuLink.setAttribute('aria-expanded', 'false');
                });
            });
        }
        function submenuEvent() {
            if (window.innerWidth > MEDIA_BREAKPOINT_LG) {
                submenuEventDSK();
            }
            else if (window.innerWidth > MEDIA_BREAKPOINT_SM && window.innerWidth <= MEDIA_BREAKPOINT_LG) {
                submenuEventTAB();
            }
            else {
                submenuEventMOB();
            }
        }
        function stickyHeader() {
            const target = headerNode.querySelector('.header-container');
            const headerTopPosition = target === null || target === void 0 ? void 0 : target.offsetTop;
            window === null || window === void 0 ? void 0 : window.addEventListener('scroll', (event) => {
                if (window.pageYOffset > headerTopPosition) {
                    target === null || target === void 0 ? void 0 : target.classList.add(STICKY_CLASS);
                }
                else {
                    target === null || target === void 0 ? void 0 : target.classList.remove(STICKY_CLASS);
                }
            });
        }
        burgerIconEvent();
        submenuEvent();
        stickyHeader();
    });
})(Header || (Header = {}));
